import { FLEET_CHARGING_SESSION_REPORT } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  fleetChargingSessions: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const fleetChargingSessionReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FLEET_CHARGING_SESSION_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }
    case FLEET_CHARGING_SESSION_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        fleetChargingSessions: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FLEET_CHARGING_SESSION_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default fleetChargingSessionReportReducer;
